export const AUTO_CLOSE_AFTER_SUCCESS_MS = 2500
